import React from "react";
import {
  ChangeTitle,
  LogOutSweetAlert,
  toAbsoluteUrl,
} from "../../helpers/Reusable";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa6";
import { IoMdLogOut } from "react-icons/io";
import { clearCookies, setCookie } from "../../helpers/CookieComponent";

const MyAccount = () => {
  ChangeTitle("My Account");
  const navigate = useNavigate();
  const location = useLocation();

  const isLogout = async () => {
    const result = await LogOutSweetAlert();
    if (result.isConfirmed) {
      clearCookies();
      setCookie("log-modal", true, {});
      navigate("/", { replace: true });
      document.location.reload();
    }
  };

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">My account</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full lg:w-[80%] mx-auto">
            <div className="md:flex md:flex-row gap-[2rem]">
              <div className="md:w-[50%]">
                <Link to={"/personalinfo"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Personal information</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/myaddress"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Address</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/mytaxidentification"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Tax Identification number</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/changepassword"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Change password</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/manageinterest"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Manage interest</span>
                  <FaChevronRight />
                </Link>
              </div>
              <div className="md:w-[50%]">
                <Link to={"/mysubscription"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>My subscription</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/myorder"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>My orders</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/mylibrary"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>My library</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/referandearn"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Refer and earn</span>
                  <FaChevronRight />
                </Link>
                <Link to={"/managenewsletter"} className="w-full px-[3rem] py-[3rem] flex justify-between items-center mb-[2rem] myacc-box">
                  <span>Manage newsletter</span>
                  <FaChevronRight />
                </Link>
              </div>
            </div>
            <button
              type="button"
              onClick={() => isLogout()}
              className="w-full p-[3rem] flex gap-3 items-center justify-center btn-logout"
            >
              <IoMdLogOut className="btn-logout-icon" />
              <span className="btn-logout-text">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyAccount;
